const state = {
  // 屏幕是否大于768 false为小于768 true为大于768
  moblie: true,
  // 详情页的提示词
  detailTitle: '',
  // 系官网的sid
  sid: "1645607191",
  // 搜索的值
  searchText: '',
  // 决定DepsDat数组的对应值
  clickCid: {
    a: 0,
    b: 0
  },
  // 固定的原数据，不能随意改动
  DepsDat: [
    // 系部概括 0
    {
      id: 1003,
      name: '系部概况',
      picName: 'xbgk',
      english: 'Department overview',
      tUrl: '@/views/home/survey/index',
      title: '系部概括--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1003,
          name: '系部概况',
          picName: 'xbgk',
          tUrl: '@/views/home/survey/index',
          title: '系部概括--茂名职业技术学院-计算机工程系',
          spanTitle: '系部概况',
          hUrl: 'xbgk.htm',
        },
        {
          cid: 1040,
          name: '组织结构',
          picName: 'xzzjg',
          tUrl: '@/views/home/survey/structure',
          title: '组织结构--茂名职业技术学院-计算机工程系',
          spanTitle: '组织结构',
          hUrl: 'zzjg.htm',
        },
        {
          cid: 1041,
          name: '专业介绍',
          picName: 'zyjs',
          tUrl: '@/views/home/survey/introduce',
          title: '专业介绍--茂名职业技术学院-计算机工程系',
          spanTitle: '专业介绍',
          hUrl: 'zyjs.htm',
        },
        {
          cid: 1009,
          name: '制度建设',
          picName: 'zdjs',
          tUrl: '@/views/home/System/index',
          title: '制度建设--茂名职业技术学院-计算机工程系',
          spanTitle: '制度建设',
          hUrl: 'zdjs.htm',
        },
        {
          cid: 1065,
          name: '领导信箱',
          picName: 'ldxx',
          tUrl: '@/views/home/email/index',
          title: '领导信箱--茂名职业技术学院-计算机工程系',
          spanTitle: '领导信箱',
          hUrl: 'ldxx.htm',
        }
      ]
    },
    // 系部新闻 1
    {
      id: 1002,
      name: '新闻公告',
      english: 'NEWS BULLETIN',
      picName: 'news',
      tUrl: '@/views/home/news/index',
      title: '系部新闻--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1002,
          name: '系部新闻',
          picName: 'xbxw',
          tUrl: '@/views/home/news/index',
          title: '系部新闻--茂名职业技术学院-计算机工程系',
          hUrl: 'xbxw.htm',
          spanTitle: '新闻动态'
        },
        {
          cid: 1023,
          name: '系部公告',
          picName: 'ggtz',
          tUrl: '@/views/home/notice/index',
          title: '系部公告--茂名职业技术学院-计算机工程系',
          hUrl: 'xbgg.htm',
          spanTitle: '通知公告'
        },
      ]
    },
    // 党建工作 2
    {
      id: 1005,
      name: '党建工作',
      picName: 'party',
      tUrl: '@/views/home/party/P_index',
      title: '党建工作--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1045,
          name: '党组织结构',
          picName: 'dzzjg',
          tUrl: '@/views/home/party/P_structure',
          title: '党组织结构--茂名职业技术学院-计算机工程系',
          hUrl: 'dzzjg.htm',
          spanTitle: '党组织结构'
        },
        {
          cid: 1046,
          name: '通知公示',
          picName: 'tzgs',
          tUrl: '@/views/home/party/P_publicity',
          title: '通知公示--茂名职业技术学院-计算机工程系',
          hUrl: 'tzgs.htm',
          spanTitle: '通知公示'
        },
        {
          cid: 1047,
          name: '党史学习',
          picName: 'dsxx',
          tUrl: '@/views/home/party/P_study',
          title: '党史学习--茂名职业技术学院-计算机工程系',
          hUrl: 'dsxx.htm',
          spanTitle: '党史学习'
        },
        {
          cid: 1048,
          name: '党日活动',
          picName: 'drhd',
          tUrl: '@/views/home/party/P_index',
          title: '党日活动--茂名职业技术学院-计算机工程系',
          hUrl: 'trhd.htm',
          spanTitle: '党日活动'
        },

      ]
    },
    // 教学科研 3
    {
      id: 1004,
      name: '教学科研',
      picName: 'teaching',
      tUrl: '@/views/home/teaching/index',
      title: '教学科研--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1004,
          name: '教学科研',
          picName: 'jxky',
          tUrl: '@/views/home/teaching/index',
          title: '教学科研--茂名职业技术学院-计算机工程系',
          hUrl: 'teaching.htm',
          spanTitle: '教学科研'
        },
        {
          cid: 1044,
          name: '教师工作室',
          picName: 'jsgzs',
          tUrl: '@/views/home/teaching/tStudio',
          title: '教师工作室--茂名职业技术学院-计算机工程系',
          hUrl: 'tStudio.htm',
          spanTitle: '教师工作室'
        },
        {
          cid: 1067,
          name: '人才培养方案',
          picName: 'rcpyfa',
          tUrl: '@/views/home/teaching/R_culture',
          title: '人才培养方案--茂名职业技术学院-计算机工程系',
          hUrl: 'rcpyfa.htm',
          spanTitle:'人才培养方案'
        },
        {
          cid: 1084,
          name: '思政教学案例',
          picName: 'szjxal',
          tUrl: '@/views/home/teaching/szjxal',
          title: '思政教学案例--茂名职业技术学院-计算机工程系',
          hUrl: 'szjxal.htm',
          spanTitle:'思政教学案例'
        }
      ]
    },
    // 学生工作 4
    {
      id: 1006,
      name: '学生工作',
      picName: 'xsgz',
      tUrl: '@/views/home/student/index',
      title: '学生工作--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1006,
          name: '学生工作',
          picName: 'xsgz',
          tUrl: '@/views/home/student/index',
          title: '学生工作--茂名职业技术学院-计算机工程系',
          hUrl: 'student.htm',
          spanTitle: '学生工作'
        },
        {
          cid: 1049,
          name: '学生社团',
          picName: 'xsst',
          tUrl: '@/views/home/student/index',
          title: '学生社团--茂名职业技术学院-计算机工程系',
          hUrl: 'xsst.htm',
          spanTitle: '学生社团'
        },
      ]
    },
    // 招生就业 5
    {
      id: 1007,
      name: '招生就业',
      picName: 'EnrEmp',
      tUrl: '@/views/home/EnrEmp/index',
      title: '招生就业--茂名职业技术学院-计算机工程系',
      children: [

        {
          cid: 1034,
          name: '招生信息',
          picName: 'zsxx',
          tUrl: '@/views/home/EnrEmp/Emp',
          title: '招生信息--茂名职业技术学院-计算机工程系',
          hUrl: 'zsxx.htm',
          spanTitle: '招生信息'
        },
        {
          cid: 1035,
          name: '就业信息',
          picName: 'jyxx',
          tUrl: '@/views/home/EnrEmp/index',
          title: '就业信息--茂名职业技术学院-计算机工程系',
          hUrl: 'jyxx.htm',
          spanTitle: '就业信息'
        },
        {
          cid: 1007,
          name: '招生就业',
          picName: 'zsjy',
          tUrl: '@/views/home/EnrEmp/Emp',
          title: '招生就业--茂名职业技术学院-计算机工程系',
          hUrl: 'zsjy.htm',
          spanTitle: '招生就业'
        },
      ]
    },
    // 教师风采 6
    {
      id: 1008,
      name: '教师风采',
      picName: 'jsfc1',
      tUrl: '@/views/home/teacher/index',
      title: '教师风采--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1008,
          name: '教师风采',
          picName: 'jsfc1',
          tUrl: '@/views/home/teacher/index',
          title: '教师风采--茂名职业技术学院-计算机工程系',
          hUrl: 'jsfc.htm',
          spanTitle: '教师风采'
        },
      ]
    },
    // 技能竞赛 7
    {
      id: 1010,
      name: '技能竞赛',
      picName: 'jnjs',
      tUrl: '@/views/home/competition/index',
      title: '技能竞赛--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1010,
          name: '技能竞赛',
          picName: 'jnjs',
          tUrl: '@/views/home/competition/index',
          title: '技能竞赛--茂名职业技术学院-计算机工程系',
          hUrl: 'jnjs.htm',
          spanTitle: '技能竞赛'
        },
      ]
    },
    // 资源下载 8
    {
      id: 1021,
      name: '资源下载',
      picName: 'zyxz',
      tUrl: '@/views/home/download/index',
      title: '资源下载--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1021,
          name: '资源下载',
          picName: 'zyxz',
          tUrl: '@/views/home/download/index',
          title: '资源下载--茂名职业技术学院-计算机工程系',
          hUrl: 'zyxz.htm',
          spanTitle: '资源下载'
        },
      ]
    },
    // 实训室管理中心 9
    {
      id: 1050,
      name: '实训室管理中心',
      picName: 'glzx',
      tUrl: '@/views/home/EnrEmp/index',
      title: '招生就业--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1051,
          name: '中心简介',
          picName: 'zxjs',
          tUrl: '@/views/platform/T_room/index',
          title: '中心简介--茂名职业技术学院-计算机工程系',
          hUrl: 'zxjj.htm',
          spanTitle: '实训室中心简介'
        },
        {
          cid: 1052,
          name: '管理制度',
          picName: 'glzd',
          tUrl: '@/views/platform/T_room/s_build',
          title: '管理制度--茂名职业技术学院-计算机工程系',
          hUrl: 'sxszd.htm',
          spanTitle: '实训室管理制度'
        },
        {
          cid: 1053,
          name: '安全工作',
          picName: 'aqgz',
          tUrl: '@/views/platform/T_room/s_work',
          title: '安全工作--茂名职业技术学院-计算机工程系',
          hUrl: 'sxsaq.htm',
          spanTitle: '实训室安全工作'
        },
        {
          cid:1094,
          name: '宣传教育',
          picName: 'xcjy',
          tUrl: '@/views/platform/T_room/s_education',
          title: '宣传教育--茂名职业技术学院-计算机工程系',
          hUrl: 'xcjy.htm',
          spanTitle: '实训室宣传教育'
        }
      ]
    },
    // 学生社团组织 10
    {
      id: 1049,
      name: '学生社团组织',
      picName: 'tw',
      tUrl: '@/views/platform/S_associations/index',
      title: '学生社团组织--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1054,
          name: '团委',
          picName: 'tw',
          tUrl: '@/views/home/party/P_structure',
          title: '团委--茂名职业技术学院-计算机工程系',
          hUrl: 'assTW.htm',
          spanTitle: '计算机工程系团委'
        },
        {
          cid: 1055,
          name: '学生会',
          picName: 'xsh',
          tUrl: '@/views/platform/S_associations/S_union',
          title: '学生会--茂名职业技术学院-计算机工程系',
          hUrl: 'assSSH.htm',
          spanTitle: '计算机工程系学生会'
        },
        {
          cid: 1056,
          name: '青协计算机分会',
          picName: 'qxjsjfh',
          tUrl: '@/views/platform/S_associations/Y_Association',
          title: '青协计算机分会--茂名职业技术学院-计算机工程系',
          hUrl: 'assQXJSJFH.htm',
          spanTitle: '青协计算机分会'
        },
        {
          cid: 1057,
          name: '学风建设委员会',
          picName: 'xfjswyh',
          tUrl: '@/views/platform/S_associations/S_com',
          title: '学风建设委员会--茂名职业技术学院-计算机工程系',
          hUrl: 'assXFJSWYH.htm',
          spanTitle: '学风建设委员会'
        },
        {
          cid: 1066,
          name: '融媒体中心',
          picName: 'rmtzx',
          tUrl: '@/views/platform/S_associations/Y_media',
          title: '融媒体中心--茂名职业技术学院-计算机工程系',
          hUrl: 'rmtzx.htm',
          spanTitle: '融媒体中心'
        },
      ]
    },
    // 图说计机 11
    {
      id: 1058,
      name: '图说计机',
      picName: 'tsjj',
      tUrl: '@/views/platform/C_computer/index',
      title: '图说计机--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1059,
          name: '校园风光',
          picName: 'xyfg',
          tUrl: '@/views/platform/C_computer/P_structure',
          title: '校园风光--茂名职业技术学院-计算机工程系',
          hUrl: 'xyfg.htm',
          spanTitle: '校园风光'
        },
        {
          cid: 1060,
          name: '计机学子',
          picName: 'jjxz',
          tUrl: '@/views/platform/C_computer/S_union',
          title: '计机学子--茂名职业技术学院-计算机工程系',
          hUrl: 'jjxz.htm',
          spanTitle: '计机学子'
        },
        {
          cid: 1061,
          name: '活动剪影',
          picName: 'hdjy',
          tUrl: '@/views/platform/C_computer/C_activity',
          title: '活动剪影--茂名职业技术学院-计算机工程系',
          hUrl: 'hdjy.htm',
          spanTitle: '活动剪影'
        },
        {
          cid: 1062,
          name: '作品展示',
          picName: 'zpzs',
          tUrl: '@/views/platform/C_computer/S_com',
          title: '作品展示--茂名职业技术学院-计算机工程系',
          hUrl: 'zpzs.htm',
          spanTitle: '作品展示'
        },

      ]
    },
    //图片新闻 12
    {
      id: 1022,
      name: '教师风采',
      picName: 'imageNews',
      tUrl: '@/views/home/imageNews/index',
      title: '图片新闻--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1022,
          name: '图片新闻',
          picName: 'tpxw',
          tUrl: '@/views/home/imageNews/index',
          title: '图片新闻--茂名职业技术学院-计算机工程系',
          hUrl: 'jsfc.htm',
          spanTitle: '图片新闻'
        },
      ]
    },
    // 搜索 13
    {
      id: 1000,
      name: '内容搜索',
      picName: 'ssxgj',
      tUrl: '@/views/home/imageNews/index',
      title: '内容搜索--茂名职业技术学院-计算机工程系',
      children: [
        {
          cid: 1000,
          name: '内容搜索',
          picName: 'ssxgj',
          tUrl: '@/views/home/imageNews/index',
          title: '内容搜索--茂名职业技术学院-计算机工程系',
          hUrl: 'ssxgj.htm',
          spanTitle: '内容搜索'
        },
      ]
    }
  ]
}

export default state
